import { useCallback, useEffect, useState } from 'react';
import { useDataSource } from '@hana/data';
import type { Customer } from './types';

/** Worker giới hạn 100 dòng / trang: gom đủ các trang cho danh bạ (tối đa MAX_PAGES). */
const PAGE = 100;
const MAX_PAGES = 100;

export function useAllCustomers() {
  const src = useDataSource();
  const [data, setData] = useState<{ items: Customer[]; total: number } | undefined>();
  const [error, setError] = useState<unknown>(null);
  const [isLoading, setLoading] = useState(true);
  const [tick, setTick] = useState(0);

  useEffect(() => {
    let live = true;
    setLoading(true);
    setError(null);
    (async () => {
      const items: Customer[] = [];
      let total = 0;
      for (let p = 0; p < MAX_PAGES; p++) {
        const page = await src.list('crmCustomer', { limit: PAGE, offset: p * PAGE });
        items.push(...page.items);
        total = page.total;
        if (page.items.length < PAGE || items.length >= total) break;
      }
      if (live) setData({ items, total: Math.max(total, items.length) });
    })()
      .catch((e) => live && setError(e))
      .finally(() => live && setLoading(false));
    return () => {
      live = false;
    };
  }, [src, tick]);

  const refetch = useCallback(() => setTick((t) => t + 1), []);
  return { data, error, isLoading, isError: error !== null, refetch };
}
